<template>
  <LayoutDetail :key="node.id" v-if="node" :node="node">
    <CompositeUnitHeader style="margin-bottom: var(--spacer-xl)" :node="node" :key="node.id" />
    <div class="details-view-unit" :class="activeBreakpoint">
      <LayoutColumns style="margin-bottom: var(--spacer)" :columns="3">
        <CompositeCardUnit
          v-for="children in node.childrens.filter((e) => !is_node_empty(e))"
          :key="children.id"
          :node="children"
        />
      </LayoutColumns>
      <h3 v-if="node.devices.length > 0" style="margin-bottom: var(--spacer-1_5)">
        <Minus color="var(--vc-primary)" /> Équipements
      </h3>
      <LayoutColumns
        v-if="node.devices.length > 0"
        :columns="3"
        style="margin-bottom: var(--spacer)"
      >
        <CompositeCardDevice v-for="device in node.devices" :device="device" :key="device.id" />
      </LayoutColumns>
      <CompositeUnitNode
        v-for="children in node.childrens.filter((e) => is_node_empty(e))"
        :node="children"
        :key="children.id"
      />
    </div>
  </LayoutDetail>
</template>

<script setup lang="ts">
import LayoutDetail from '@/components/layout/LayoutDetail.vue'
import CompositeCardDevice from '@/components/composite/CompositeCardDevice.vue'
import { useRoute } from 'vue-router'
import { onBeforeMount, ref, watch } from 'vue'
import CompositeCardUnit from '@/components/composite/CompositeCardUnit.vue'
import LayoutColumns from '@/components/layout/LayoutColumns.vue'
import { is_node_empty, type ApplicationTreeNode } from '@/service/service_unit'
import CompositeUnitNode from '@/components/composite/CompositeUnitNode.vue'
import CompositeReporting from '@/components/composite/CompositeReporting.vue'
import { useBreakpoints } from '@vueuse/core'
import { application_breakpoints } from '@/service/service_breakpoints'
import CompositeUnitHeader from '@/components/composite/CompositeUnitHeader.vue'
import { Minus } from 'lucide-vue-next'
import { useOrganizationUnitStore } from '@/stores/store_organization_unit'

const store = useOrganizationUnitStore()
const route = useRoute()
const node = ref<ApplicationTreeNode>()
const breakpoints = useBreakpoints(application_breakpoints)
const activeBreakpoint = breakpoints.active()

function unit_init(id: string) {
  node.value = store.getByID(id) ?? undefined
}

watch(
  () => route.params.id,
  (id) => unit_init(id as string)
)

onBeforeMount(() => {
  unit_init(route.params.id as string)
})
</script>

<style scoped lang="scss">
@import '@/assets/mixins.scss';
.details-view {
  &-top {
    display: flex;
    gap: var(--spacer-xl);
    margin-bottom: var(--spacer-xl);
    max-height: 400px;

    &-right {
      width: 100%;
    }
  }

  &-bottom {
    @include hlayout(var(--spacer-xl));
    justify-content: space-between;
    margin-bottom: var(--spacer-xl);

    &-left {
      @include hlayout(var(--spacer-1_5));
      flex-wrap: wrap;
      flex: auto;

      .layout-card {
        flex: 0 0 360px;
      }
    }

    &-right {
      flex: 1 1 350px;
    }
  }

  &-units {
    display: flex;
    gap: var(--spacer);
    margin-bottom: var(--spacer-1_5);
    flex-wrap: wrap;
  }
}

.tablet,
.mobile {
  .details-view {
    &-top {
      flex-direction: column;
    }
  }
}

.details-view-unit {
  margin-bottom: var(--spacer);
}

.img-container {
  border-radius: var(--br-medium);
  overflow: hidden;
  min-width: 570px;
  max-width: 570px;
  max-height: 400px;
}

.img-container > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
